// @ts-nocheck
window.watchAdvisorProduct = (eventName, elements) => {
    try {
        if (elements && elements.length > 0) {
            const limitedElements = Array.from(elements).slice(0, 20);
            let products = Array.from(limitedElements).map((item) => ({
                productId: item.getAttribute('product-id'),
                productSku: item.getAttribute('product-sku'),
                productPrice: item.getAttribute('product-price'),
                productAvailability: item.getAttribute('product-availability') ? 'Instock' : 'Out of Stock',
                productName: item.getAttribute('product-name'),
                productVendor: item.getAttribute('product-vendor'),
                productType: item.getAttribute('product-type'),
                productVariant: item.getAttribute('product-variant'),
                comparePrice: item.getAttribute('compare-price')
            }));

            const productData = Array.from(limitedElements).reduce(
                (acc, item) => {
                  const attributesData = [
                    "product-id",
                    "product-sku",
                    "product-price",
                    "product-availability",
                    "product-name",
                    "product-vendor",
                    "product-type",
                    "product-variant",
                    "compare-price"
                  ];
              
                  attributesData.forEach(attr => {
                    let value = item.getAttribute(attr);
                    
                    // Handle product-availability separately
                    if (attr === "product-availability" && value !== null) {
                      value = value === "true" ? "Instock" : "Out of Stock";
                    }
              
                    if (value !== null) {
                      acc[attr] = acc[attr] ? acc[attr] + "," + value : value;
                    }
                  });
              
                  return acc;
                },
                {}
              );

            dataLayer.push({
                event: eventName,
                productCount: limitedElements.length,
                products: products,
                productIds: productData["product-id"],
                productSkus: productData["product-sku"],
                productPrices: productData["product-price"],
                productAvailability: productData["product-availability"],
                productNames: productData["product-name"],
                productVendors: productData["product-vendor"],
                productTypes: productData["product-type"],
                productVariants: productData["product-variant"],
                comparePrices: productData["compare-price"]
            });
        }
    } catch (e) {
        console.log(e);
    }
};

/**
 * Defer work until after the next frame so pointer/click INP processing stays low
 * (same pattern as theme utilities / web.dev INP guidance).
 * @param {() => void} fn
 */
function __deferAfterPaint(fn) {
    requestAnimationFrame(function () {
        setTimeout(fn, 0);
    });
}

document.addEventListener(
    'click',
    function (event) {
        const addButton = event.target.closest('button[name="add"]');
        if (!addButton || document.querySelector('.know-your-price-btn')) return;

        __deferAfterPaint(function () {
            try {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'custom_add_to_cart',
                    productId: addButton.dataset.id,
                    productSku: addButton.dataset.sku,
                    productName: addButton.dataset.title,
                    productAvailability: addButton.dataset.availability ? 'Instock' : 'Out of Stock',
                    productPrice: parseFloat(addButton.dataset.price) / 100,
                    comparePrice: parseFloat(addButton.dataset.compareAtPrice) / 100 || null,
                    productVendor: addButton.dataset.vendor,
                    productType: addButton.dataset.type,
                    productVariant: addButton.dataset.variantId,
                });
            } catch (e) {
                console.log(e);
            }
        });
    },
    { passive: true }
);
window.quizGTMData = (labelName, data1, data2, data3, data4) => {
    let advisorValue = [data1, data2, data3, data4]
        .filter(value => value !== undefined && value !== null)
        .join(' ');

    dataLayer.push({
        event: "watch advisor",
        [labelName]: advisorValue,
    });
}

(function setupWishlistGtmDelegation() {
    function wishlistHrefToProductJsonUrl(href) {
        if (!href) return null;
        try {
            const u = new URL(href, window.location.origin);
            u.search = '';
            u.hash = '';
            const path = u.pathname.replace(/\/$/, '');
            if (path.endsWith('.js')) return u.origin + path;
            return u.origin + path + '.js';
        } catch {
            return null;
        }
    }

    function resolveWishlistProductHref(wishlistEl) {
        const fromLink = wishlistEl.closest('a[href*="/products/"]');
        if (fromLink) return fromLink.getAttribute('href');
        const cardRoot = wishlistEl.closest('.card__inner, .card-wrapper, .product-card-wrapper, .card, .product-card');
        if (cardRoot) {
            const a = cardRoot.querySelector('a.full-unstyled-link[href*="/products/"], a[href*="/products/"]');
            if (a) return a.getAttribute('href');
        }
        return null;
    }

    function pushAddedToWishlistFromCardData(wishlistEl) {
        const cardRoot = wishlistEl.closest('.card__inner, .card-wrapper, .product-card-wrapper');
        const dataEl = cardRoot && cardRoot.querySelector('.data-container-event[product-id]');
        if (!dataEl) return false;

        const productId = dataEl.getAttribute('product-id');
        if (!productId) return false;

        const rawCompare = dataEl.getAttribute('compare-price');
        const comparePrice = rawCompare !== null && rawCompare !== '' ? parseFloat(rawCompare, 10) : null;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Added to Wishlist',
            productId: Number(productId) || productId,
            productName: dataEl.getAttribute('product-name') || undefined,
            productVendor: dataEl.getAttribute('product-vendor') || undefined,
            productType: dataEl.getAttribute('product-type') || undefined,
            productPrice: parseFloat(dataEl.getAttribute('product-price'), 10) || undefined,
            comparePrice: Number.isFinite(comparePrice) ? comparePrice : null,
            productSku: dataEl.getAttribute('product-sku') || undefined,
            productVariant: dataEl.getAttribute('product-variant') || undefined,
            productAvailability: dataEl.getAttribute('product-availability') === 'true' ? 'Instock' : 'Out of Stock',
        });
        return true;
    }

    function pushAddedToWishlistMinimalFromEl(wishlistEl) {
        const productId = wishlistEl.getAttribute('data-product');
        if (!productId) return false;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'Added to Wishlist',
            productId: Number(productId) || productId,
        });
        return true;
    }

    function handleWishlistClickForGtm(wishlistEl) {
        try {
            const productHref = resolveWishlistProductHref(wishlistEl);
            const jsonUrl = wishlistHrefToProductJsonUrl(productHref);

            if (jsonUrl) {
                fetch(jsonUrl)
                    .then((response) => {
                        if (!response.ok) {
                            throw new Error(`HTTP error! Status: ${response.status}`);
                        }
                        return response.json();
                    })
                    .then((productWish) => {
                        if (!productWish || !productWish.variants || productWish.variants.length === 0) {
                            if (!pushAddedToWishlistFromCardData(wishlistEl)) pushAddedToWishlistMinimalFromEl(wishlistEl);
                            return;
                        }

                        window.dataLayer = window.dataLayer || [];
                        window.dataLayer.push({
                            event: 'Added to Wishlist',
                            productId: productWish.id,
                            productName: productWish.title,
                            productVendor: productWish.vendor,
                            productType: productWish.type,
                            productPrice: productWish.price / 100,
                            comparePrice: productWish.compare_at_price
                                ? productWish.compare_at_price / 100
                                : null,
                            productSku: productWish.variants[0].sku,
                            productVariant: productWish.variants[0].title,
                            productAvailability: productWish.available ? 'Instock' : 'Out of Stock',
                        });
                    })
                    .catch(() => {
                        if (!pushAddedToWishlistFromCardData(wishlistEl)) pushAddedToWishlistMinimalFromEl(wishlistEl);
                    });
            } else {
                if (!pushAddedToWishlistFromCardData(wishlistEl)) pushAddedToWishlistMinimalFromEl(wishlistEl);
            }
        } catch (error) {
            console.error('Error in wishlist click event:', error);
        }
    }

    function bindWishlistGtm(main) {
        if (!main) return;
        main.addEventListener(
            'click',
            function (event) {
                const wishlistEl = event.target.closest('.smartwishlist');
                if (!wishlistEl || !wishlistEl.classList.contains('unbookmarked')) return;

                setTimeout(function () {
                    handleWishlistClickForGtm(wishlistEl);
                }, 0);
            },
            false
        );
    }
    function initWishlistGtm() {
        bindWishlistGtm(document.getElementById('MainContent'));
    }
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initWishlistGtm, { once: true });
    } else {
        initWishlistGtm();
    }
})();

window.commonGTMData = (eventName, elements) => {
    try {
        if (elements && elements.length > 0) {
            let products = Array.from(elements).map((item) => ({
                productId: item.getAttribute('product-id'),
                productSku: item.getAttribute('product-sku'),
                productPrice: item.getAttribute('product-price'),
                productAvailability: item.getAttribute('product-availability') ? 'Instock' : 'Out of Stock',
                productName: item.getAttribute('product-name'),
                productVendor: item.getAttribute('product-vendor'),
                productType: item.getAttribute('product-type'),
                productVariant: item.getAttribute('product-variant'),
                comparePrice: item.getAttribute('compare-price')
            }));

            const productData = Array.from(elements).reduce(
                (acc, item) => {
                  const attributesData = [
                    "product-id",
                    "product-sku",
                    "product-price",
                    "product-availability",
                    "product-name",
                    "product-vendor",
                    "product-type",
                    "product-variant",
                    "compare-price"
                  ];
              
                  attributesData.forEach(attr => {
                    let value = item.getAttribute(attr);
                    
                    // Handle product-availability separately
                    if (attr === "product-availability" && value !== null) {
                      value = value === "true" ? "Instock" : "Out of Stock";
                    }
              
                    if (value !== null) {
                      acc[attr] = acc[attr] ? acc[attr] + "," + value : value;
                    }
                  });
              
                  return acc;
                },
                {}
              );
              
            dataLayer.push({
                event: eventName,
                products: products,
                productIds: productData["product-id"],
                productSkus: productData["product-sku"],
                productPrices: productData["product-price"],
                productAvailability: productData["product-availability"],
                productNames: productData["product-name"],
                productVendors: productData["product-vendor"],
                productTypes: productData["product-type"],
                productVariants: productData["product-variant"],
                comparePrices: productData["compare-price"]
            });
        }
    } catch (e) {
        console.log(e);
    }
};

window.recentProductsGTMData = (eventName, elements) => {
    try {
        if (!Array.isArray(elements) || elements.length === 0) return;

        const limitedElements = elements.slice(0, 20).filter(Boolean);
        if (limitedElements.length === 0) return;

        const products = limitedElements.map((item) => {
            const firstVariant = Array.isArray(item.variants) && item.variants.length > 0 ? item.variants[0] : null;
            const productPriceRaw = item.price ?? firstVariant?.price ?? null;
            const comparePriceRaw = item.compare_at_price ?? firstVariant?.compare_at_price ?? null;

            return {
                productId: item.id ?? null,
                productSku: firstVariant?.sku ?? null,
                productPrice: productPriceRaw !== null ? Number(productPriceRaw) / 100 : null,
                productAvailability: item.available ? 'Instock' : 'Out of Stock',
                productName: item.title ?? null,
                productVendor: item.vendor ?? null,
                productType: item.type ?? null,
                productVariant: firstVariant?.title ?? null,
                comparePrice: comparePriceRaw !== null ? Number(comparePriceRaw) / 100 : null,
            };
        });

        const productData = products.reduce((acc, product) => {
            const attributesData = [
                ['product-id', product.productId],
                ['product-sku', product.productSku],
                ['product-price', product.productPrice],
                ['product-availability', product.productAvailability],
                ['product-name', product.productName],
                ['product-vendor', product.productVendor],
                ['product-type', product.productType],
                ['product-variant', product.productVariant],
                ['compare-price', product.comparePrice],
            ];

            attributesData.forEach(([key, value]) => {
                if (value === null || value === undefined || value === '') return;
                acc[key] = acc[key] ? `${acc[key]},${value}` : `${value}`;
            });

            return acc;
        }, {});

        dataLayer.push({
            event: eventName,
            productCount: products.length,
            products: products,
            productIds: productData['product-id'],
            productSkus: productData['product-sku'],
            productPrices: productData['product-price'],
            productAvailability: productData['product-availability'],
            productNames: productData['product-name'],
            productVendors: productData['product-vendor'],
            productTypes: productData['product-type'],
            productVariants: productData['product-variant'],
            comparePrices: productData['compare-price'],
        });
    } catch (e) {
        console.log(e);
    }
};
window.filterSortBy = (filterValue) => {
    try {
        dataLayer.push({
            event: "Filter- Sort By",
            filterValue: filterValue,
        })
    } catch (e) {
        console.log(e)
    }
}

window.eventHandler = (element) => {
    try {
        let productData = JSON.parse(element.getAttribute("data-product"));
        let eventName = element.getAttribute('event-name')
        let productId = productData.id;
        let productAvailability = productData.available;
        let productSku = productData.variants[0].sku;
        let productName = productData.title;
        let productVendor = productData.vendor;
        let productPrice = productData.price / 100;
        let productType = productData.type;
        let productVariant = productData.variants[0].title;
        let comparePrice = productData.compare_at_price / 100;
        dataLayer.push({
            event: `${eventName}`,
            productId: productId,
            productAvailability: productAvailability ? 'Instock' : 'Out of Stock',
            productSku: productSku,
            productName: productName,
            productVendor: productVendor,
            productPrice: productPrice,
            productType: productType,
            productVariant: productVariant,
            comparePrice: comparePrice
        });
    } catch (error) {
        console.error('JSON Parse Error:', error);
    }
};

window.notifyMeEventHandler = (element, phone) => {
    try {
        let productData = JSON.parse(element.getAttribute("data-product"));
        let variantID = productData.variants[0].id;
        let productAvailability = productData.available;
        let productSku = productData.variants[0].sku;
        let productName = productData.title;
        let productVendor = productData.vendor;
        let productPrice = productData.price / 100;
        let productType = productData.type;
        let productVariant = productData.variants[0].title;
        let comparePrice = productData.compare_at_price / 100;
        dataLayer.push({
            event: 'Notify Me',
            phoneNumber: phone,
            variantID: variantID,
            productAvailability: productAvailability ? 'Instock' : 'Out of Stock',
            productSku: productSku,
            productName: productName,
            productVendor: productVendor,
            productPrice: productPrice,
            productType: productType,
            productVariant: productVariant,
            comparePrice: comparePrice
        });
    } catch (error) {
        console.error('JSON Parse Error:', error);
    }
};

window.dataLayer = window.dataLayer || [];
window.runOnSMLEvent = async (event, data) => {
    if (event == 'USER_REGISTERED_SUCCESSFULLY') {
        try {
            sessionStorage.setItem('customerRegistered', 'true');
        } catch (error) {
            console.error('Error in Customer Registered event:', error);
        }
    }
};

(function() {
    const pagePath = window.location.pathname;
    dataLayer.push({
        page_path: pagePath,
    });
  })();

document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('#gokwik-buy-now')?.addEventListener('click', function (e) {
        const parentElement = e.target.closest('.product-form-buttons');
        const childElement = parentElement?.querySelector('.btn-text')
        if(childElement){
            eventHandler(childElement)
        }
    });

    if (window.location.pathname.includes('/search')) {
        const countSource =
            document.querySelector('#ProductCountDesktop') ||
            document.querySelector('.products-count-wrapper span');
        const countText = countSource ? countSource.textContent || '' : '';
        const matchedCount = countText.replace(/,/g, '').match(/\d+/);
        const searchResultCount = matchedCount ? Number(matchedCount[0]) : document.querySelectorAll('.product-grid__item').length;

        window.dataLayer.push({
            event: 'search',
            searchResultCount: searchResultCount,
        });
    }
    
    const sections = document.querySelectorAll(".shopify-section");
    
    const observerContainer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let targetId = entry.target;
                let getSection = targetId.querySelector('.pdp-tabs-container');
                
                if (getSection) {
                    let similarProducts = document.querySelectorAll('#tab-content-1 product-recommendations ul .grid__item');
                    
                    if (similarProducts.length > 0) {
                        let products = Array.from(similarProducts).map((item) => ({
                            productId: item.getAttribute('product-id'),
                            productSku: item.getAttribute('product-sku'),
                            productPrice: item.getAttribute('product-price'),
                            productAvailability: item.getAttribute('product-availability') ? 'Instock' : 'Out of Stock',
                            productName: item.getAttribute('product-name'),
                            productVendor: item.getAttribute('product-vendor'),
                            productType: item.getAttribute('product-type'),
                            productVariant: item.getAttribute('product-variant'),
                            comparePrice: item.getAttribute('compare-price')
                        }));
                        const productData = Array.from(similarProducts).reduce(
                            (acc, item) => {
                              const attributesData = [
                                "product-id",
                                "product-sku",
                                "product-price",
                                "product-availability",
                                "product-name",
                                "product-vendor",
                                "product-type",
                                "product-variant",
                                "compare-price"
                              ];
                          
                              attributesData.forEach(attr => {
                                let value = item.getAttribute(attr);
                                
                                // Handle product-availability separately
                                if (attr === "product-availability" && value !== null) {
                                  value = value === "true" ? "Instock" : "Out of Stock";
                                }
                          
                                if (value !== null) {
                                  acc[attr] = acc[attr] ? acc[attr] + "," + value : value;
                                }
                              });
                          
                              return acc;
                            },
                            {}
                          );

                        dataLayer.push({
                            event: "View Similar",
                            products: products,
                            productIds: productData["product-id"],
                            productSkus: productData["product-sku"],
                            productPrices: productData["product-price"],
                            productAvailability: productData["product-availability"],
                            productNames: productData["product-name"],
                            productVendors: productData["product-vendor"],
                            productTypes: productData["product-type"],
                            productVariants: productData["product-variant"],
                            comparePrices: productData["compare-price"]
                        });
                    }
                }
            }
        });
    }, { threshold: 0.5 });

    sections.forEach(section => observerContainer.observe(section));
});